import { IApartmentFinishing } from '../../../repositories/developer-card/entities/developer_special_promo/ApartmentFinishing';
import { IApplicationState } from '../../../types/redux';

import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoApartmentFinishing(state: IApplicationState): IApartmentFinishing | undefined {
  return getTemplateSpecialPromo(state)?.apartmentFinishing ?? undefined;
}
